<template>
  <layout-div>
    <div class="row justify-content-md-center justify-content-sm-center justify-content-lg-center full-screen-bg">
      <div class="col-12 col-md-6 col-sm-10 col-lg-6 col-xl-4">
        <div class="logo-brand-box">
            <img src="@/assets/Logo_pro.png" alt="Logo" class="logo" />
        </div>
        <div class="card login-box mt-2" style="background-color:  #1f2441;">
          <div class="card-body">
            <h5 class="card-title mb-4" style="color: white;">Anmelden</h5>
            <form>
              <div class="mb-3" style="text-align: left;">
                <label for="email" class="form-label label-left">Benutzername</label>
                <input v-model="username" placeholder="Benutzername" type="email" class="form-control" id="email" name="email" required />
              </div>
              <div class="mb-3" style="text-align: left;">
                <label for="password" class="form-label label-left">Passwort</label>
                <input v-model="password" placeholder="Passwort" type="password" class="form-control" id="password" name="password" required />
              </div>
              <p v-if="Object.keys(validationErrors).length != 0" class="text-center">
                <small class="text-danger">Die Authentifizierung ist fehlgeschlagen. Bitte geben Sie gültige Anmeldedaten ein und überprüfen Sie, ob der Benutzer gesperrt ist.</small>
              </p>
              <div class="d-grid gap-2 pb-4 pt-3">
                <button 
                  :disabled="isSubmitting || username.trim() === '' || password.trim() === ''"
                  @click="authenticateUser"
                  type="button"
                  class="btn btn-block text-white"
                  style="background-color: #121738;"
                >
                  <span v-if="isSubmitting" class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
                  <span v-else>Anmelden</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout-div>
</template>

  
<script>
import axios from 'axios';
import tokenService from '@/tokenService';
import LayoutDiv from './LayoutDiv.vue';
import { API_BASE_URL } from '../config';
export default {
  name: 'LoginPage',
  components: {
    LayoutDiv,
  },
  data() {
    return {
      username: '',
      password: '',
      validationErrors:{},
      isSubmitting:false,
    };
  },
  methods: {
    authenticateUser() {
    this.isSubmitting = true
    const token = tokenService.getToken();
    const tokenReceivedTime = tokenService.getTokenReceivedTime();
    const credentials = {
      username: (token && !tokenService.isTokenExpired()) ? tokenService.getStoredUsername() : this.username,
      password: (token && !tokenService.isTokenExpired()) ? tokenService.getStoredPassword() : this.password,
      lifetime: 3600
    };
    if (token && !tokenService.isTokenExpired()) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      axios
        .post(`${API_BASE_URL}/api/rest/v2/application/tokens`, credentials)
        .then((response) => {
          const tokenData = response.data;
          const newToken = tokenData.tokens[0];
          // console.log('New Token:', newToken);
          tokenService.storeToken(newToken);
          tokenService.storeUsername(credentials.username);
          tokenService.storePassword(credentials.password);
          this.$router.push({
            name: 'timeTracking'
          })
        })
        .catch(error => {
            this.isSubmitting = false
           if (error.response.data.errors != undefined) {
                this.validationErrors = error.response.data.errors
            }
            if (error.response.data.error != undefined) {
                this.validationErrors = error.response.data.error
            }
            return error
          });
    }
  },
      // authenticateUser() {
      //   const token = localStorage.getItem('token');
      //   const tokenReceivedTime = localStorage.getItem('tokenReceivedTime');
      //         const credentials = {
      //           username: this.username,
      //           password: this.password,
      //           lifetime: 3600
      //         };
      //         axios
      //           .post(`${API_BASE_URL}/api/rest/v2/application/tokens`, credentials)
      //           .then((response) => {
      //             const tokenData = response.data;
      //             const token = tokenData.tokens[0];
      //             console.log('Token:', token);
      //             this.$router.push({
      //                 name: 'timeTracking'
      //             })
      //         })
      //         .catch((error) => {
      //             alert('Invalid credentials. Please try again.');
      //         });
      // },
  },
};
</script>

<style>
.login-box {
  background: #fff;
  text-align: center;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
}


.label-left {
  color: white;
  text-align: left;
}

.login-heading {
  font-size: 28px;
  color: #333;
}

.form-control {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.btn-primary {
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #2980b9;
}

@media screen and (max-width: 600px) {
  .login-box {
    border-radius: 0;
  }
  .login-heading {
    font-size: 24px;
  }
}

@media (max-width: 767px) {
  body, html {
    background-color: #121738;
  }
}
body, html {
  height: 100%;
  margin: 0;
  padding: 0;
}

.full-screen-bg {
  background-color: #121738;
  height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: auto;
}

.logo-brand-box {
  display: inline-block;
  padding: 7px;
  border: 0 solid rgb(99, 149, 173);
  border-radius: 5px;
  margin-top: 30%;
  height:auto;
  width:40%;
  margin-bottom: 5%;
}
</style>